<div>
  <nx-pageTitle-box
  [label]="contactTitle"
  [bcRootLvlLabel]="'rentModule.customerViewComponent.breadcrumb.root' | translate"
  [bcRootLvlPath]="'/customers'"
  [icon]="Contact?.getContactIcon(customer?.type)"
  [iconToolTip]="Contact?.getContactType(customer?.type)">
  </nx-pageTitle-box>
  <div class="bodyWrapper flex flex-row gap-5">
    <div class="basis-2/3 mt-[10px] widthFixForTable">
      <p-tabView [(activeIndex)]="activeIndex" [scrollable]="true">
        <p-tabPanel [header]="'rentModule.customerViewComponent.tabs.orders' | translate">
          <div class="mt-[1.25rem]">
            <app-orders-list
              class="basis-full full"
              [customer]="customer?.id"
              *ngIf="customer?.id"
              [withMainHeadline]="false">
            </app-orders-list>
          </div>
        </p-tabPanel>
        <p-tabPanel
          [header]="'rentModule.customerViewComponent.tabs.contactPersons' | translate"
          *ngIf="rolesService?.hasRole('nexcore_contactPerson_view')">
          <div class="mt-[1.25rem]">
            <app-contact-person-list class="mt-2" [contact]="customer?.id"></app-contact-person-list>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Vorgänge">
          <app-issue-list
            [showTabs]="false"
            [targetEntityType]="'Contact'"
            [targetEntityId]="customer?.id"
            [showPageTitle]="false"
            *ngIf="customer">
          </app-issue-list>
        </p-tabPanel>
      </p-tabView>
    </div>
    <div class="basis-1/3 mt-[11px]">
      <div class="flex flex-col">
        <div class="basis-full">
          <div>
            <nx-headline-box class="mb-2" [label]="'rentModule.customerViewComponent.sections.general' | translate" appearance="underline"
            class="mb-[1.25rem]">
            </nx-headline-box>
            <nx-headline-box [label]="'rentModule.customerViewComponent.sections.customerData' | translate">
            </nx-headline-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.contactId' | translate">
              {{customer?.number? customer.number: '-'}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.type' | translate">
              {{contactType? contactType: '-'}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.salutation' | translate"
              *ngIf="customer?.type?.toString() === 'INDIVIDUAL'">
              {{customer?.salutation}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.firstName' | translate"
              *ngIf="customer?.type?.toString() === 'INDIVIDUAL'">
              {{customer?.firstName}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.lastName' | translate"
              *ngIf="customer?.type?.toString() === 'INDIVIDUAL'">
              {{customer?.lastName}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.companyName' | translate"
              *ngIf="customer?.type?.toString() === 'COMPANY'">
              {{customer?.companyName}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.companyNameExtension' | translate"
              *ngIf="customer?.type?.toString() === 'COMPANY'">
              {{customer?.companyNameExtension}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.phone' | translate">
              {{customer?.phone? customer.phone: '-'}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.email' | translate">
              {{customer?.email? customer.email: '-'}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.street' | translate">
              {{customer?.address?.street? customer?.address?.street: '-'}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.houseNumber' | translate">
              {{customer?.address?.houseNumber? customer?.address?.houseNumber: '-'}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.postalCode' | translate">
              {{customer?.address?.postalCode? customer?.address?.postalCode: '-'}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.city' | translate">
              {{customer?.address?.city? customer?.address?.city: '-'}}
            </nx-default-box>
            <nx-default-box class="bg-white border-b border-gray" [label]="'rentModule.customerViewComponent.fields.country' | translate">
              {{customer?.address?.country? customer.address?.country: '-'}}
            </nx-default-box>
          </div>
          <div *ngFor="let section of customAttributeSections; let index = index; let isLast = last" class="mt-2">
            <nx-headline-box
              [label]="CheckSectionInAttributes(section?.id)? section?.label : 'Title'">
            </nx-headline-box>
            <nx-default-box
              *ngFor="let defintion of section?.customAttributeDefinitions; let isLast = last"
              class="bg-white border-b border-gray"
              [label]="defintion?.label">
              <ng-container
                *ngIf="defintion?.type !== 'DATETIME'">
                {{getValue(defintion?.id)}}
              </ng-container>
              <ng-container
                *ngIf="defintion?.type === 'DATETIME'">
                (getValue(defintion?.id) | date:'dd.MM.yyyy HH:mm')
              </ng-container>
            </nx-default-box>
          </div>
        </div>
      </div>
    </div>
</div>

